import request from '@/utils/request'

export default {
  logout () {
    return request({
      url: '/auth/logout',
      method: 'get'
    })
  },
  profile (cancelToken) {
    return request({
      // cancelToken: cancelToken.token,
      url: '/auth/me',
      method: 'get'
    })
  },
  loginPremium () {
    return request({
      url: `${process.env.VUE_APP_API}/v3/auth/login/premium`,
      method: 'get'
    })
  },
  updateProfile (data) {
    return request({
      url: '/auth/me',
      method: 'put',
      data
    })
  },
  updatePassword (data) {
    return request({
      url: '/auth/me',
      method: 'post',
      data
    })
  },
  fetchFavorites () {
    return request({
      url: '/favorites',
      method: 'get'
    })
  },
  addFavorite (data) {
    return request({
      url: `/favorites`,
      method: 'post',
      data
    })
  },
  removeFavorite (data) {
    return request({
      url: `/favorites`,
      method: 'delete',
      data
    })
  },
  fetchPoints () {
    return request({
      url: 'auth/me/points',
      method: 'get'
    })
  },
  fetchCoupons (params) {
    return request({
      url: `${process.env.VUE_APP_API}/v3/me/coupons`,
      method: 'get',
      params
    })
  },
  addCoupon (data) {
    return request({
      url: `${process.env.VUE_APP_API}/v3/me/coupons`,
      method: 'post',
      data
    })
  },
  fetchNight () {
    return request({
      url: `${process.env.VUE_APP_API}/v3/me/night`,
      method: 'get'
    })
  },
  addCouponViaNight () {
    return request({
      url: `${process.env.VUE_APP_API}/v3/me/coupons/night`,
      method: 'post'
    })
  },
  fetchCouponNightPreview () {
    return request({
      url: `${process.env.VUE_APP_API}/v3/me/coupons/night/preview`,
      method: 'get'
    })
  },
  fetchCouponsHistory (params) {
    return request({
      url: `${process.env.VUE_APP_API}/v3/me/coupons/history`,
      method: 'get',
      params
    })
  },
  getCountryList () {
    return request({
      url: 'place/country',
      method: 'get'
    })
  },
  sendInvitation (data) {
    return request({
      url: 'auth/me/invites',
      method: 'post',
      data
    })
  },
  subscribeEmail (data) {
    return request({
      url: 'subscriptions',
      method: 'post',
      data
    })
  },
  fetchPointsRecords (params) {
    return request({
      url: `${process.env.VUE_APP_API}/v3/me/points`,
      method: 'get',
      params
    })
  }
}
